import vehicleInfoService from '@/services/vehicle-info'
import { isEmpty, isNull, mergeWith } from 'lodash-es'
import {
  FETCH_DETAIL,
  SET_BASIC_INFO,
  SET_INFO,
  FETCH_MODELS,
  FETCH_MAKES,
  FETCH_YEARS,
  FETCH_BADGES,
  FETCH_ALL,
  SET_PREV_LENGTH,
  SET_REGO_SEARCH_FLAG,
  SET_STATE,
  FETCH_INIT,
  RESET_OPTIONS,
  SET_REDBOOK_FLAG,
  SET_OTHER_OPTIONS,
  SET_LOADING_AG,
  SET_CURRENT_API_PARAMS,
} from './actions'
import {
  FETCH_DETAIL_SUCCESS,
  SET_BASIC_INFO_SUCCESS,
  SET_INFO_SUCCESS,
  FETCH_MODELS_SUCCESS,
  FETCH_YEARS_SUCCESS,
  FETCH_MAKES_SUCCESS,
  FETCH_BADGES_SUCCESS,
  FETCH_DETAIL_EXTENDED_SUCCESS,
  FETCH_ALL_SUCCESS,
  SET_PREV_LENGTH_SUCCESS,
  SET_VARIANT_LIST_SUCCESS,
  SET_REGO_SEARCH_FLAG_SUCCESS,
  NARROWS_DOWN_RBC,
  SET_STATE_SUCCESS,
  FETCH_INIT_SUCCESS,
  RESET_OPTIONS_SUCCESS,
  SET_REDBOOK_FLAG_SUCCESS,
  SET_OTHER_OPTIONS_SUCCESS,
  SET_LOADING_AG_SUCCESS,
  SET_CURRENT_API_PARAMS_SUCCESS,
} from './mutations'
import { blankOptionList } from "@/helper/constant";

const state = {
  makes: [],
  models: [],
  drives: [],
  transmissions: [],
  shifts: [],
  badges: [],
  badgeEditions: [],
  editions: [],
  years: [],
  fuelTypes: [],
  bodyTypes: [],
  series: [],
  engineTypes: [],
  modelYears: [],
  engineSizes: [],
  numberOfSeats: [],
  colors: [
    'White',
    'Grey',
    'Silver',
    'Black',
    'Blue',
    'Red',
    'Green',
    'Orange',
    'Gold',
    'Yellow',
    'Bronze',
    'Other',
  ],
  curVehicleInfo: {
    make: '',
    model: '',
    badge: '',
    edition: '',
    year: '',
    color: '',
    model_year: '',
    fuelType: '',
    bodyType: '',
    series: '',
    engineType: '',
    rego: '',
    vin: '',
    drive: '',
    transmission: '',
    shift: '',
    key: '',
    kms: '',
    logBook: true,
    fullServiceHistory: true,
    ownerManual: '',
    serviceHistory: '',
    interior: null,
    exterior: null,
    reservePrice: '',
    customerName: '',
    customerEmail: '',
    customerMobile: '',
    customerPostalCode: '',
    location: '',
    sell: '',
    badgeEdition: '',
    description: '',
    conditionDescription: '',
    pickUp: '',
    outstandingFinance: '',
    writtenOff: '',
    majorAccident: '',
    hailOrFlooding: '',
    tyreReplacement: '',
    sellerFees: false,
    sellerTerms: false,
    marketingComm: true,
    selfServiceStatus: '',
    rbcs: [],
    redbookDataMapper: null,
    stolen: '',
    lookupFailures: [],
    engineSize: '',
    numberOfSeat: '',
    advertised: '',
    platform: [],
  },
  isClearOptions: {
    isClearBadgeEdition: false,
    isClearBody: false,
    isClearFuel: false,
    isClearDrive: false,
    isClearTrans: false,
    isClearSeries: false,
    isClearEngine: false,
  },
  prevLength: {
    prevLengthBadgeEdition: 0,
    prevLengthBody: 0,
    prevLengthFuel: 0,
    prevLengthDrive: 0,
    prevLengthTrans: 0,
    prevLengthSeries: 0,
    prevLengthEngine: 0,
  },
  warningLights: '',
  serviceHistoryDetail: '',
  relevantRBDesc: '',
  regoLookupFlag: false,
  isCalledRedbook: false,
  isLoadingAG: false,
  currentAPIParams: {},
}

let oldParams = {};

const getters = {
  makes(state) {
    return state.makes
  },
  models(state) {
    return state.models
  },
  drives(state) {
    return state.drives
  },
  badges(state) {
    return state.badges
  },
  badgeEditions(state) {
    return state.badgeEditions
  },
  editions(state) {
    return state.editions
  },
  transmissions(state) {
    return state.transmissions
  },
  shifts(state) {
    return state.shifts
  },
  colors(state) {
    return state.colors
  },
  years(state) {
    return state.years
  },
  fuelTypes(state) {
    return state.fuelTypes
  },
  bodyTypes(state) {
    return state.bodyTypes
  },
  series(state) {
    return state.series
  },
  engineTypes(state) {
    return state.engineTypes
  },
  modelYears(state) {
    return state.modelYears
  },
  engineSizes(state) {
    return state.engineSizes
  },
  numberOfSeats(state) {
    return state.numberOfSeats
  },
  isCalledRedbook(state) {
    return state.isCalledRedbook
  },
  curVehicleInfo(state) {
    return {
      ...state.curVehicleInfo,
      make: state.curVehicleInfo.make !== null ? state.curVehicleInfo.make : '',
      model: state.curVehicleInfo.model !== null ? state.curVehicleInfo.model : '',
      badge: state.curVehicleInfo.badge !== null ? state.curVehicleInfo.badge : '',
      edition: state.curVehicleInfo.edition !== null ? state.curVehicleInfo.edition : '',
      drive: state.curVehicleInfo.drive !== null ? state.curVehicleInfo.drive : '',
      transmission: state.curVehicleInfo.transmission !== null ? state.curVehicleInfo.transmission : '',
      shift: state.curVehicleInfo.transmission !== null ? state.curVehicleInfo.transmission : '',
      year: state.curVehicleInfo.year !== null ? state.curVehicleInfo.year : '',
      color: state.curVehicleInfo.color !== null ? state.curVehicleInfo.color : '',
      fuelType: state.curVehicleInfo.fuelType !== null ? state.curVehicleInfo.fuelType : '',
      bodyType: state.curVehicleInfo.bodyType !== null ? state.curVehicleInfo.bodyType : '',
      series: state.curVehicleInfo.series !== null ? state.curVehicleInfo.series : '',
      engineType: state.curVehicleInfo.engineType !== null ? state.curVehicleInfo.engineType : '',
      model_year: state.curVehicleInfo.model_year !== null ? state.curVehicleInfo.model_year : '',
      reservePrice: state.curVehicleInfo.reservePrice !== null && state.curVehicleInfo.reservePrice >= 0 ? state.curVehicleInfo.reservePrice : '',
      customerName: state.curVehicleInfo.customerName !== null ? state.curVehicleInfo.customerName : '',
      customerEmail: state.curVehicleInfo.customerEmail !== null ? state.curVehicleInfo.customerEmail : '',
      customerMobile: state.curVehicleInfo.customerMobile !== null ? state.curVehicleInfo.customerMobile : '',
      customerPostalCode: state.curVehicleInfo.customerPostalCode !== null ? state.curVehicleInfo.customerPostalCode : '',
      location: state.curVehicleInfo.area !== null ? state.curVehicleInfo.location : '',
      ownerManual: state.curVehicleInfo.ownerManual !== null ? state.curVehicleInfo.ownerManual : '',
      sell: state.curVehicleInfo.sell !== null ? state.curVehicleInfo.sell : '',
      badgeEdition: state.curVehicleInfo.badgeEdition !== null ? state.curVehicleInfo.badgeEdition : '',
      description: state.curVehicleInfo.description !== null ? state.curVehicleInfo.description : '',
      conditionDescription: state.curVehicleInfo.conditionDescription !== null ? state.curVehicleInfo.conditionDescription : '',
      pickUp: state.curVehicleInfo.pickUp !== null ? state.curVehicleInfo.pickUp : '',
      outstandingFinance: state.curVehicleInfo.outstandingFinance !== null ? state.curVehicleInfo.outstandingFinance : '',
      writtenOff: state.curVehicleInfo.writtenOff !== null ? state.curVehicleInfo.writtenOff : '',
      stolen: state.curVehicleInfo.stolen !== null ? state.curVehicleInfo.stolen : '',
      majorAccident: state.curVehicleInfo.majorAccident !== null ? state.curVehicleInfo.majorAccident : '',
      hailOrFlooding: state.curVehicleInfo.hailOrFlooding !== null ? state.curVehicleInfo.hailOrFlooding : '',
      tyreReplacement: state.curVehicleInfo.tyreReplacement !== null ? state.curVehicleInfo.tyreReplacement : '',
      sellerFees: state.curVehicleInfo.sellerFees !== undefined ? state.curVehicleInfo.sellerFees : false,
      sellerTerms: state.curVehicleInfo.sellerTerms !== undefined ? state.curVehicleInfo.sellerTerms : false,
      marketingComm: state.curVehicleInfo.marketingComm !== undefined ? state.curVehicleInfo.marketingComm : true,
      warningLights: state.curVehicleInfo.warningLights !== null ? state.curVehicleInfo.warningLights : '',
      serviceHistoryDetail: state.curVehicleInfo.serviceHistoryDetail !== null ? state.curVehicleInfo.serviceHistoryDetail : '',
      relevantRBDesc: state.curVehicleInfo.relevantRBDesc !== null ? state.curVehicleInfo.relevantRBDesc : '',
      selfServiceStatus: state.curVehicleInfo.selfServiceStatus !== null ? state.curVehicleInfo.selfServiceStatus : '',
      engineSize: state.curVehicleInfo.engineSize !== null ? state.curVehicleInfo.engineSize : '',
      numberOfSeat: state.curVehicleInfo.numberOfSeat !== null ? state.curVehicleInfo.numberOfSeat : '',
      advertised: state.curVehicleInfo.advertised !== null ? state.curVehicleInfo.advertised : '',
      platform: state.curVehicleInfo.platform !== null ? state.curVehicleInfo.platform : [],
    }
  }
}

const setClear = {
  setClearBody(state) {
    if (state.bodyTypes.length === 1 && state.prevLength.prevLengthBody > state.bodyTypes.length) {
      state.isClearOptions.isClearBody = true;
    } else {
      state.isClearOptions.isClearBody = false;
    }
  },
  setClearDrive(state) {
    if (state.drives.length === 1 && state.prevLength.prevLengthDrive > state.drives.length) {
      state.isClearOptions.isClearDrive = true;
    } else {
      state.isClearOptions.isClearDrive = false;
    }
  },
  setClearSeries(state) {
    if (state.series.length === 1 && state.prevLength.prevLengthSeries > state.series.length) {
      state.isClearOptions.isClearSeries = true;
    } else {
      state.isClearOptions.isClearSeries = false;
    }
  },
  setClearTrans(state) {
    if (state.transmissions.length === 1 && state.prevLength.prevLengthTrans > state.transmissions.length) {
      state.isClearOptions.isClearTrans = true;
    } else {
      state.isClearOptions.isClearTrans = false;
    }
  },
  setClearEngine(state) {
    if (state.engineTypes.length === 1 && state.prevLength.prevLengthEngine > state.engineTypes.length) {
      state.isClearOptions.isClearEngine = true;
    } else {
      state.isClearOptions.isClearEngine = false;
    }
  },
  setClearFuel(state) {
    if (state.fuelTypes.length === 1 && state.prevLength.prevLengthFuel > state.fuelTypes.length) {
      state.isClearOptions.isClearFuel = true;
    } else {
      state.isClearOptions.isClearFuel = false;
    }
  },
  setClearBadgeEdition(state) {
    if (state.badgeEditions.length === 1 && state.prevLength.prevLengthBadgeEdition > state.badgeEditions.length) {
      state.isClearOptions.isClearBadgeEdition = true;
    } else {
      state.isClearOptions.isClearBadgeEdition = false;
    }
  },
  setClearEngineSize(state) {
    if (state.engineSizes.length === 1 && state.prevLength.prevLengthEngineSize > state.engineSizes.length) {
      state.isClearOptions.isClearEngineSize = true;
    } else {
      state.isClearOptions.isClearEngineSize = false;
    }
  },
  setClearNumberOfSeat(state) {
    if (state.numberOfSeats.length === 1 && state.prevLength.prevLengthNumberOfSeat > state.numberOfSeats.length) {
      state.isClearOptions.isClearNumberOfSeat = true;
    } else {
      state.isClearOptions.isClearNumberOfSeat = false;
    }
  },
}

const setters = {
  setYear(state, payload) {
    state.years = payload.data.years
    if (payload.data.years.length === 1 && payload.data.models[0] !== payload.authenticateSeller.carInfo.model) {
      payload.authenticateSeller.carInfo.year = payload.data.years[0];
    } else if (!payload.data.years.includes(Number(payload.authenticateSeller.carInfo.year))) {
      payload.authenticateSeller.carInfo.year = '';
    }
  },
  setModel(state, payload) {
    state.models = [...payload.data.models, 'Other'];
    if (payload.data.models.length === 1 && payload.data.models[0] !== payload.authenticateSeller.carInfo.model) {
      payload.authenticateSeller.carInfo.model = payload.data.models[0];
    } else if (!payload.data.models.includes(payload.authenticateSeller.carInfo.model)) {
      payload.authenticateSeller.carInfo.model = '';
    }
  },
  setBadge(state, payload) {
    if (payload.data.badges?.length >= 2) {
      state.badges = [...payload.data.badges, 'Other', 'Not sure'];
    } else if (payload.data?.badges && payload.data.badges.length > 0) {
      state.badges = [...payload.data.badges, 'Other'];
    }
    if (payload.data.badges?.length === 1 && payload.data.badges[0] !== payload.authenticateSeller.carInfo.badge) {
      payload.authenticateSeller.carInfo.badge = payload.data.badges[0];
    } else if (
      !payload.data.badges?.includes(payload.authenticateSeller.carInfo.badge) &&
      !blankOptionList.includes(payload.authenticateSeller.carInfo.badge)
    ) {
      payload.authenticateSeller.carInfo.badge = "";
    }
  },
  setEdition(state, payload) {
    if (payload.data.editions?.length >= 2) {
      state.editions = [...payload.data.editions, 'Other', 'Not sure'];
    } else if (payload.data?.editions && payload.data.editions.length > 0) {
      state.editions = [...payload.data.editions, 'Other'];
    }
    if (payload.data.editions?.length === 1 && payload.data.editions[0] !== payload.authenticateSeller.carInfo.edition) {
      payload.authenticateSeller.carInfo.edition = payload.data.editions[0];
    } else if (
      !payload.data.editions?.includes(payload.authenticateSeller.carInfo.edition) &&
      !blankOptionList.includes(payload.authenticateSeller.carInfo.edition)
    ) {
      payload.authenticateSeller.carInfo.edition = "";
    }
  },
  setBody(state, payload) {
    state.bodyTypes = payload.data.bodyTypes
    if (payload.data.bodyTypes.length === 1 && payload.data.bodyTypes[0] !== payload.authenticateSeller.carInfo.bodyType) {
      payload.authenticateSeller.carInfo.bodyType = payload.data.bodyTypes[0];
    } else if (!payload.data.bodyTypes.includes(payload.authenticateSeller.carInfo.bodyType.toUpperCase())) {
      payload.authenticateSeller.carInfo.bodyType = '';
    }
    setClear.setClearBody(state);
  },
  setDrive(state, payload) {
    state.drives = payload.data.drives
    if (payload.data.drives.length === 1 && payload.data.drives[0] !== payload.authenticateSeller.carInfo.drive) {
      payload.authenticateSeller.carInfo.drive = payload.data.drives[0];
    } else if (!payload.data.drives.includes(payload.authenticateSeller.carInfo.drive)) {
      payload.authenticateSeller.carInfo.drive = '';
    }
    setClear.setClearDrive(state);
  },
  setSeries(state, payload) {
    if (payload.data.series.length >= 2) {
      state.series = [...payload.data.series, 'Other', 'Not sure'];
    } else {
      state.series = [...payload.data.series, 'Other'];
    }
    if (payload.data.series.length === 1 && payload.data.series[0] !== payload.authenticateSeller.carInfo.series) {
      payload.authenticateSeller.carInfo.series = payload.data.series[0];
    } else if (
      !payload.data.series.includes(payload.authenticateSeller.carInfo.series) &&
      !blankOptionList.includes(payload.authenticateSeller.carInfo.series)
    ) {
      payload.authenticateSeller.carInfo.series = "";
    }
    setClear.setClearSeries(state);
  },
  setTrans(state, payload) {
    state.transmissions = payload.data.transmissions
    if (payload.data.transmissions.length === 1 && payload.data.transmissions[0] !== payload.authenticateSeller.carInfo.transmission) {
      payload.authenticateSeller.carInfo.transmission = payload.data.transmissions[0];
    } else if (!payload.data.transmissions.includes(payload.authenticateSeller.carInfo.transmission)) {
      payload.authenticateSeller.carInfo.transmission = '';
    }
    setClear.setClearTrans(state);
  },
  setEngine(state, payload) {
    if (payload.data.engineTypes.length >= 2) {
      state.engineTypes = [...payload.data.engineTypes, 'Not sure'];
    } else {
      state.engineTypes = payload.data.engineTypes;
    }
    if (payload.data.engineTypes.length === 1 && payload.data.engineTypes[0] !== payload.authenticateSeller.carInfo.engineType) {
      payload.authenticateSeller.carInfo.engineType = payload.data.engineTypes[0];
    } else if (
      !payload.data.engineTypes.includes(payload.authenticateSeller.carInfo.engineType) &&
      payload.authenticateSeller.carInfo.engineType !== "Not sure"
    ) {
      payload.authenticateSeller.carInfo.engineType = "";
    }
    setClear.setClearEngine(state);
  },
  setModelYear(state, payload) {
    const dataList = payload.data.modelYears.filter(item => item != '')
    if (dataList.length >= 2) {
      state.modelYears = [...dataList, 'Not sure'];
    } else {
      state.modelYears = dataList;
    }
    if (dataList.length === 1 && dataList[0] !== payload.authenticateSeller.carInfo.model_year) {
      payload.authenticateSeller.carInfo.model_year = dataList[0];
    } else if (
      !dataList.includes(payload.authenticateSeller.carInfo.model_year) &&
      payload.authenticateSeller.carInfo.model_year !== "Not sure"
    ) {
      payload.authenticateSeller.carInfo.model_year = "";
    }
  },
  setFuelType(state, payload) {
    state.fuelTypes = payload.data.fuelTypes
    // Skip set fuelType if skipSetValue is true
    if (!payload.params?.skipSetValue) {
      if (payload.data.fuelTypes.length === 1 && payload.data.fuelTypes[0] !== payload.authenticateSeller.carInfo.fuelType) {
        payload.authenticateSeller.carInfo.fuelType = payload.data.fuelTypes[0];
      } else if (!payload.data.fuelTypes.includes(payload.authenticateSeller.carInfo.fuelType)) {
        payload.authenticateSeller.carInfo.fuelType = '';
      }
    }
    setClear.setClearFuel(state)
  },
  setBadgeEdition(state, payload) {
    let arr = [];
    payload?.data?.badges?.forEach((badge, index) => {
      if (badge === '') {
        arr.push({
          key: `N/A`,
          value: `N/A|N/A`
        })
      } else {
        arr.push({
          key: `${badge} ${payload.data.editions[index]}`,
          value: `${badge}|${payload.data.editions[index]}`
        })
      }
    });
    state.badgeEditions = arr;
    if (state.badgeEditions.length >= 2) {
      state.badgeEditions = [...state.badgeEditions, { key: "Other", value: "Other|Other"}, { key: "Not sure", value: "Not sure|Not sure"}];
    } else if (state.badgeEditions.length > 0) {
      state.badgeEditions = [...state.badgeEditions, { key: "Other", value: "Other|Other"}];
    }
    
    // Skip set badgeEdition if skipSetValue is true
    if (!payload.params?.skipSetValue) {
      if (state.badgeEditions.length === 1 && state.badgeEditions[0].value !== payload.authenticateSeller.carInfo.badgeEdition) {
        payload.authenticateSeller.carInfo.badgeEdition = state.badgeEditions[0].value;
      } else if (
        !state.badgeEditions.some(
          (item) =>
            item.value === payload.authenticateSeller.carInfo.badgeEdition ||
            payload.authenticateSeller.carInfo.badgeEdition
              .trim()
              .toUpperCase()
              .includes(item.key.trim().toUpperCase())
        ) &&
        payload.authenticateSeller.carInfo.badgeEdition !== "Other|Other" &&
        payload.authenticateSeller.carInfo.badgeEdition !== "Not sure|Not sure"
      ) {
        payload.authenticateSeller.carInfo.badgeEdition = "";
      }
    }
    
    setClear.setClearBadgeEdition(state);
    setClear.setClearBody(state);
    setClear.setClearDrive(state);
    setClear.setClearSeries(state);
    setClear.setClearTrans(state);
    setClear.setClearEngine(state);
    setClear.setClearFuel(state);
    setClear.setClearEngineSize(state);
    setClear.setClearNumberOfSeat(state);
  },
  setEngineSize(state, payload) {
    state.engineSizes = payload.data.engineSizes
    if (payload.data.engineSizes.length === 1 && payload.data.engineSizes[0] !== payload.authenticateSeller.carInfo.engineSize) {
      payload.authenticateSeller.carInfo.engineSize = payload.data.engineSizes[0];
    } else if (!payload.data.engineSizes.includes(payload.authenticateSeller.carInfo.engineSize)) {
      payload.authenticateSeller.carInfo.engineSize = '';
    }
    setClear.setClearEngineSize(state);
  },
  setNumberOfSeat(state, payload) {
    state.numberOfSeats = payload.data.numberOfSeats
    if (payload.data.numberOfSeats.length === 1 && payload.data.numberOfSeats[0] !== Number(payload.authenticateSeller.carInfo.numberOfSeat)) {
      payload.authenticateSeller.carInfo.numberOfSeat = payload.data.numberOfSeats[0];
    } else if (!payload.data.numberOfSeats.includes(Number(payload.authenticateSeller.carInfo.numberOfSeat))) {
      payload.authenticateSeller.carInfo.numberOfSeat = '';
    }
    setClear.setClearNumberOfSeat(state);
  },
}

const actions = {
  [FETCH_INIT](context, params) {
    // Set current API params
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params);

    const authenticateSeller = context.rootState.authenticateSeller;
    return new Promise((resolve, reject) => {
      vehicleInfoService.getInfo(params)
        .then(({ data }) => {
          context.commit(NARROWS_DOWN_RBC, data)
          context.commit(FETCH_INIT_SUCCESS, { data, params, authenticateSeller })
          // Set loading to false when API completes
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
        })
        .then(() => {
          if (context.state.regoLookupFlag) {
            context.commit(SET_VARIANT_LIST_SUCCESS, authenticateSeller)
          }
          resolve();
        })
        .catch(err => {
          // Set loading to false on error
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
          reject(err);
        })
    })
  },
  [FETCH_ALL](context, params) {
    // Set current API params
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params);

    const authenticateSeller = context.rootState.authenticateSeller;
    return new Promise((resolve, reject) => {
      vehicleInfoService.getInfo(params)
        .then(({ data }) => {
          context.commit(NARROWS_DOWN_RBC, data)
          context.commit(FETCH_ALL_SUCCESS, { data, params, authenticateSeller })
          // Set loading to false when API completes
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
        })
        .then(() => {
          if (state.regoLookupFlag) {
            context.commit(SET_VARIANT_LIST_SUCCESS, authenticateSeller)
          }
        })
        .catch(err => {
          // Set loading to false on error
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
          reject(err);
        })
    })
  },
  [FETCH_DETAIL](context, params) {
    const authenticateSeller = context.rootState.authenticateSeller;
    if (JSON.stringify(oldParams) !== JSON.stringify(params)) {
      oldParams = { ...params };

      // Set current API params
      context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params);

      return new Promise((resolve, reject) => {
        vehicleInfoService.getInfo(params)
          .then(({ data }) => {
            context.commit(NARROWS_DOWN_RBC, data)
            context.commit(FETCH_DETAIL_SUCCESS, { data, params, authenticateSeller })
            // Set loading to false when API completes
            if (context.rootGetters.isAGSource) {
              context.commit(SET_LOADING_AG_SUCCESS, false);
            }
            resolve(data);
          })
          .then(() => {
            if (state.regoLookupFlag) {
              context.commit(SET_VARIANT_LIST_SUCCESS, authenticateSeller)
            }
          })
          .catch(err => {
            // Set loading to false on error
            if (context.rootGetters.isAGSource) {
              context.commit(SET_LOADING_AG_SUCCESS, false);
            }
            reject(err);
          })
      })
    } else {
      // Params are the same, no need to fetch but still set loading to false
      if (context.rootGetters.isAGSource) {
        context.commit(SET_LOADING_AG_SUCCESS, false);
      }
      return Promise.resolve();
    }
  },
  [FETCH_MODELS](context, params) {
    // Set current API params
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params);

    const authenticateSeller = context.rootState.authenticateSeller;
    return new Promise((resolve, reject) => {
      vehicleInfoService.getInfo(params)
        .then(({ data }) => {
          context.commit(NARROWS_DOWN_RBC, data)
          context.commit(FETCH_MODELS_SUCCESS, { data, params, authenticateSeller })
          context.commit(FETCH_DETAIL_EXTENDED_SUCCESS, { data, params, authenticateSeller })
          // Set loading to false when API completes
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
        })
        .catch(err => {
          // Set loading to false on error
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
          reject(err);
        })
    })
  },
  [FETCH_MAKES](context) {
    // Set current API params
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, {});

    return new Promise((resolve, reject) => {
      vehicleInfoService.getInfo({})
        .then(({ data }) => {
          context.commit(NARROWS_DOWN_RBC, data)
          context.commit(FETCH_MAKES_SUCCESS, { data })
          // Set loading to false when API completes
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
        })
        .catch(err => {
          // Set loading to false on error
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
          reject(err);
        })
    })
  },
  [FETCH_YEARS](context, params) {
    // Set current API params
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params);

    const authenticateSeller = context.rootState.authenticateSeller;
    return new Promise((resolve, reject) => {
      vehicleInfoService.getInfo(params)
        .then(({ data }) => {
          context.commit(NARROWS_DOWN_RBC, data)
          context.commit(FETCH_YEARS_SUCCESS, { data, params, authenticateSeller })
          context.commit(FETCH_DETAIL_EXTENDED_SUCCESS, { data, params, authenticateSeller })
          // Set loading to false when API completes
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
        })
        .catch(err => {
          // Set loading to false on error
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
          reject(err);
        })
    })
  },
  [FETCH_BADGES](context, params) {
    // Set current API params
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params);

    const authenticateSeller = context.rootState.authenticateSeller;
    return new Promise((resolve, reject) => {
      vehicleInfoService.getInfo(params)
        .then(({ data }) => {
          context.commit(NARROWS_DOWN_RBC, data)
          context.commit(FETCH_BADGES_SUCCESS, { data, params, authenticateSeller })
          context.commit(FETCH_DETAIL_EXTENDED_SUCCESS, { data, params, authenticateSeller })
          // Set loading to false when API completes
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
        })
        .catch(err => {
          // Set loading to false on error
          if (context.rootGetters.isAGSource) {
            context.commit(SET_LOADING_AG_SUCCESS, false);
          }
          reject(err);
        })
    })
  },
  [SET_BASIC_INFO](context, data) {
    context.commit(SET_BASIC_INFO_SUCCESS, data)
  },
  [SET_INFO](context, data) {
    context.commit(SET_INFO_SUCCESS, data)
  },
  setBadges(context, data) {
    context.commit('setBadges', data)
  },
  [SET_PREV_LENGTH](context, data) {
    context.commit(SET_PREV_LENGTH_SUCCESS, data)
  },
  [SET_REGO_SEARCH_FLAG](context, data) {
    context.commit(SET_REGO_SEARCH_FLAG_SUCCESS, data)
  },
  [SET_STATE](context, data) {
    context.commit(SET_STATE_SUCCESS, data)
  },
  [RESET_OPTIONS](context) {
    context.commit(RESET_OPTIONS_SUCCESS);
  },
  [SET_REDBOOK_FLAG](context, data) {
    context.commit(SET_REDBOOK_FLAG_SUCCESS, data)
  },
  [SET_OTHER_OPTIONS](context, params) {
    // Set current API params
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params);

    const authenticateSeller = context.rootState.authenticateSeller;
    if (params !== 'other') {
      return new Promise((resolve, reject) => {
        vehicleInfoService.getInfo(params)
          .then(({ data }) => {
            context.commit(NARROWS_DOWN_RBC, data)
            context.commit(FETCH_YEARS_SUCCESS, { data, params, authenticateSeller })
            context.commit(FETCH_DETAIL_EXTENDED_SUCCESS, { data, params, authenticateSeller })
            context.commit(SET_OTHER_OPTIONS_SUCCESS, authenticateSeller)
            // Set loading to false when API completes
            if (context.rootGetters.isAGSource) {
              context.commit(SET_LOADING_AG_SUCCESS, false);
            }
          })
          .catch(err => {
            // Set loading to false on error
            if (context.rootGetters.isAGSource) {
              context.commit(SET_LOADING_AG_SUCCESS, false);
            }
            reject(err);
          })
      })
    } else {
      context.commit(SET_OTHER_OPTIONS_SUCCESS, authenticateSeller)
    }
  },
  [SET_LOADING_AG](context, isLoading) {
    context.commit(SET_LOADING_AG_SUCCESS, isLoading)
  },
  [SET_CURRENT_API_PARAMS](context, params) {
    context.commit(SET_CURRENT_API_PARAMS_SUCCESS, params)
  },
}

const mutations = {
  [FETCH_INIT_SUCCESS](state, payload) {
    state.makes = payload.data.makes
    if (payload.data.makes.length === 1) {
      state.curVehicleInfo.make = payload.data.makes[0];
    }
    if (payload.data.models.length >= 2) {
      state.models = [...payload.data.models, 'Other'];
    } else {
      state.models = payload.data.models;
    }
    state.years = payload.data.years
    state.bodyTypes = payload.data.bodyTypes
    state.drives = payload.data.drives
    state.transmissions = payload.data.transmissions

    const dataList = payload.data.modelYears.filter(item => item != '')
    if (dataList.length >= 2) {
      state.modelYears = [...dataList, 'Not sure'];
    } else {
      state.modelYears = dataList;
    }

    setters.setFuelType(state, payload)
    setters.setSeries(state, payload)
    setters.setEngine(state, payload)
    setters.setEngineSize(state, payload)
    setters.setNumberOfSeat(state, payload)
    setters.setBadgeEdition(state, payload)
  },
  [FETCH_ALL_SUCCESS](state, payload) {
    state.makes = payload.data.makes
    if (payload.data.makes.length === 1) {
      state.curVehicleInfo.make = payload.data.makes[0];
    }
    setters.setModel(state, payload)
    setters.setYear(state, payload)
    setters.setBadge(state, payload)
    setters.setEdition(state, payload)
    setters.setBadgeEdition(state, payload)
    setters.setBody(state, payload)
    setters.setDrive(state, payload)
    setters.setSeries(state, payload)
    setters.setTrans(state, payload)
    setters.setEngine(state, payload)
    setters.setFuelType(state, payload)
    setters.setModelYear(state, payload)
    setters.setEngineSize(state, payload)
    setters.setNumberOfSeat(state, payload)

    payload.authenticateSeller.carInfo.relevantRBDesc = "";
  },
  [FETCH_DETAIL_SUCCESS](state, payload) {
    setters.setBadge(state, payload)
    setters.setEdition(state, payload)
    setters.setBadgeEdition(state, payload)
    setters.setBody(state, payload)
    setters.setDrive(state, payload)
    setters.setSeries(state, payload)
    setters.setTrans(state, payload)
    setters.setEngine(state, payload)
    setters.setFuelType(state, payload)
    setters.setModelYear(state, payload)
    setters.setEngineSize(state, payload)
    setters.setNumberOfSeat(state, payload)

    payload.authenticateSeller.carInfo.relevantRBDesc = "";
  },
  [FETCH_DETAIL_EXTENDED_SUCCESS](state, payload) {
    setters.setBody(state, payload)
    setters.setDrive(state, payload)
    setters.setSeries(state, payload)
    setters.setTrans(state, payload)
    setters.setEngine(state, payload)
    setters.setFuelType(state, payload)
    setters.setModelYear(state, payload)
    setters.setEngineSize(state, payload)
    setters.setNumberOfSeat(state, payload)

    payload.authenticateSeller.carInfo.relevantRBDesc = "";
  },
  [FETCH_MAKES_SUCCESS](state, payload) {
    state.makes = payload.data.makes
    if (payload.data.makes.length === 1) {
      state.curVehicleInfo.make = payload.data.makes[0];
    }
    setters.setModel(state, payload)
    setters.setYear(state, payload)
    setters.setBadge(state, payload)
    setters.setEdition(state, payload)
    setters.setBadgeEdition(state, payload)
    setters.setModelYear(state, payload)
  },
  [FETCH_MODELS_SUCCESS](state, payload) {
    setters.setModel(state, payload)
    setters.setYear(state, payload)
    setters.setBadge(state, payload)
    setters.setEdition(state, payload)
    setters.setBadgeEdition(state, payload)
    setters.setModelYear(state, payload)

    payload.authenticateSeller.carInfo.relevantRBDesc = "";
  },
  [FETCH_YEARS_SUCCESS](state, payload) {
    setters.setYear(state, payload)
    setters.setBadge(state, payload)
    setters.setEdition(state, payload)
    setters.setBadgeEdition(state, payload)
    setters.setModelYear(state, payload)

    payload.authenticateSeller.carInfo.relevantRBDesc = "";
  },
  [FETCH_BADGES_SUCCESS](state, payload) {
    setters.setBadge(state, payload)
    setters.setEdition(state, payload)
    setters.setBadgeEdition(state, payload)
    setters.setModelYear(state, payload)

    payload.authenticateSeller.carInfo.relevantRBDesc = "";
  },
  [SET_BASIC_INFO_SUCCESS](state, data) {
    state.curVehicleInfo = {
      ...state.curVehicleInfo,
      ...data
    }
  },
  [SET_INFO_SUCCESS](state, data) {
    if (isEmpty(data)) {
      state.curVehicleInfo = {
        make: '',
        model: '',
        badge: '',
        edition: '',
        year: '',
        color: '',
        model_year: '',
        fuelType: '',
        bodyType: '',
        series: '',
        engineType: '',
        rego: 'REGOSKIPPED',
        vin: '',
        drive: '',
        shift: '',
        key: '',
        transmission: '',
        kms: '',
        logBook: false,
        fullServiceHistory: false,
        ownerManual: '',
        serviceHistory: '',
        interior: null,
        exterior: null,
        reservePrice: '',
        customerName: '',
        customerEmail: '',
        customerMobile: '',
        customerPostalCode: '',
        location: '',
        sell: '',
        badgeEdition: '',
        description: '',
        conditionDescription: '',
        pickUp: '',
        outstandingFinance: '',
        writtenOff: 'No',
        majorAccident: '',
        hailOrFlooding: '',
        tyreReplacement: '',
        sellerFees: false,
        sellerTerms: false,
        marketingComm: true,
        warningLights: '',
        serviceHistoryDetail: '',
        relevantRBDesc: '',
        selfServiceStatus: '',
        rbcs: [],
        redbookDataMapper: null,
        stolen: 'No',
        lookupFailures: [],
        engineSize: '',
        numberOfSeat: '',
        advertised: '',
        platform: [],
      }
    } else {
      state.curVehicleInfo = mergeWith({}, state.curVehicleInfo, data, (o, s) => isNull(s) ? o : s)
    }
  },
  setBadges(state, data) {
    state.badges = [...data, 'Not sure'];
  },
  [SET_VARIANT_LIST_SUCCESS](state, authenticateSeller) {
    setters.setBadge(state, {
      data: { badges: authenticateSeller.carInfo.badges },
      authenticateSeller,
    });
    setters.setEdition(state, {
      data: { editions: authenticateSeller.carInfo.editions },
      authenticateSeller,
    });
    setters.setBadgeEdition(state, {
      data: {
        badges: authenticateSeller.carInfo.badges,
        editions: authenticateSeller.carInfo.editions,
      },
      authenticateSeller,
    });
  },
  [SET_REGO_SEARCH_FLAG_SUCCESS](state, data) {
    state.regoLookupFlag = data;
  },
  [SET_PREV_LENGTH_SUCCESS](state, data) {
    state.prevLength[data.prevLengthName] = state[data.stateName].length
  },
  [NARROWS_DOWN_RBC](state, data) {
    if (!isEmpty(state.curVehicleInfo.rbcs) && data.rbcs && Array.isArray(data.rbcs)) {
      const targetRbcs = [];
      state.curVehicleInfo.rbcs.forEach(rbc => {
        if (data.rbcs.includes(rbc)) targetRbcs.push(rbc);
      })
      state.curVehicleInfo = {
        ...state.curVehicleInfo,
        rbcs: targetRbcs,
      }
    }
  },
  [SET_STATE_SUCCESS](state, data) {
    state.curVehicleInfo.rego = data.regoValue;
    state.curVehicleInfo.location = data.stateValue;
  },
  [RESET_OPTIONS_SUCCESS](state) {
    state.makes = [];
    state.models = [];
    state.drives = [];
    state.transmissions = [];
    state.shifts = [];
    state.badges = [];
    state.badgeEditions = [];
    state.editions = [];
    state.years = [];
    state.fuelTypes = [];
    state.bodyTypes = [];
    state.series = [];
    state.engineTypes = [];
    state.modelYears = [];
    state.colors = [
      'White',
      'Grey',
      'Silver',
      'Black',
      'Blue',
      'Red',
      'Green',
      'Orange',
      'Gold',
      'Yellow',
      'Bronze',
      'Other',
    ];
    state.engineSizes = [];
    state.numberOfSeats = [];
  },
  [SET_REDBOOK_FLAG_SUCCESS](state, data) {
    state.isCalledRedbook = data;
  },
  [SET_OTHER_OPTIONS_SUCCESS](state, authenticateSeller) {
    authenticateSeller.carInfo = {
      ...authenticateSeller.carInfo,
      badge: 'Other',
      edition: 'Other',
      badgeEdition: 'Other|Other',
      series: 'Other',
    }
  },
  [SET_LOADING_AG_SUCCESS](state, isLoading) {
    state.isLoadingAG = isLoading;
  },
  [SET_CURRENT_API_PARAMS_SUCCESS](state, params) {
    state.currentAPIParams = params;
  },
}
export default {
  state,
  getters,
  actions,
  mutations
}
